import React from 'react';
import EditableBranchTemplate from '../components/EditableBranchTemplate';
import { hackathonData } from '../data/hackathonData';

const Hackathon = () => {
  const handleSave = (updatedContent) => {
    console.log('Saving updated content:', updatedContent);
    alert('Content saved successfully! (Check console for details)');
  };

  return (
    <EditableBranchTemplate
      title="Web3 Hackathons"
      sections={hackathonData}
      onSave={handleSave}
    />
  );
};

export default Hackathon;
